var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',[_c('button',{staticStyle:{"border":"none","background":"none","margin-right":"5px"},on:{"click":function($event){return _vm.saveMeeting()}}},[_c('Icon',{attrs:{"icon":"material-symbols:save-outline","color":"#7367f0","width":"25","height":"25"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }